<template>
  <div>
    <form
      @submit.prevent="next"
      method="post"
      action="/textLabels"
      accept-charset="UTF-8"
      id="mainForm"
    >
      <div class="tw-px-2 tw-pb-4 tw-mb-8 tw-bg-white tw-shadow-md tw-h-auto">
        <div class="parent">
          <div class="child">
            <label
              class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5"
              :class="scene ? 'tw-text-gray-1020' : 'tw-text-white'"
              >Where did the injury occur?</label
            >
            <select
              id="scene"
              v-model="scene"
              @change="onChangeScene($event)"
              placeholder="Where did the injury occur?"
              :class="[
                errors.length > 0 && scene === undefined ? 'error select_error' : 'tw-text-black',
                scene !== undefined ? 'tw-font-medium' : 'tw-font-normal',
              ]"
            >
              <option disabled selected value="undefined">Where did the injury occur?</option>
              <option v-for="item in sceneType" :key="item.id" :value="item.id" :label="item.name">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <Transition name="other">
          <div class="tw-w-full parent" v-show="scene === 2">
            <div class="child">
              <input
                id="sceneOther"
                class="input tw-pt-2.5 tw-px-2 tw-pb-2"
                autocomplete="off"
                v-model="sceneOther"
                placeholder="Please describe the location where the injury occured"
                :class="[
                  errors.length > 0 && scene === 2 ? 'error input_error' : 'tw-text-black',
                  sceneOther !== undefined ? 'tw-font-medium' : 'tw-font-normal',
                ]"
              />
            </div></div
        ></Transition>

        <div
          v-if="activeRoleType === roles.programAdmin || activeRoleType === roles.clubProgramAdmin"
        >
          <div class="parent">
            <div class="child">
              <label
                class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5"
                :class="programId ? 'tw-text-gray-1020' : 'tw-text-white'"
                >Select Program</label
              >
              <select
                id="programId"
                v-model="programId"
                @change="getProgramMembers($event)"
                :class="[
                  scene === 1 && errors.length > 0 && programId === undefined
                    ? 'error select_error'
                    : 'tw-text-black',
                  programId !== undefined ? 'tw-font-medium' : 'tw-font-normal',
                ]"
              >
                <option value="undefined" :disabled="true">Select program</option>
                <option
                  v-for="item in programs"
                  :key="item._id"
                  :value="item._id"
                  :label="item.name"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="parent">
            <div class="child">
              <label
                class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5"
                :class="competitionId ? 'tw-text-gray-1020' : 'tw-text-white'"
                >Select competition</label
              >
              <select
                id="competitionId"
                v-model="competitionId"
                :disabled="scene > 1"
                @change="onChangeCompetition($event)"
                :class="[
                  scene === 1 && errors.length > 0 && competitionId === undefined
                    ? 'error select_error'
                    : 'tw-text-black',
                  competitionId !== undefined ? 'tw-font-medium' : 'tw-font-normal',
                ]"
              >
                <option value="undefined" :disabled="true">Select competition</option>
                <option v-for="item in competitions" :key="item._id" :value="item._id">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="parent">
            <div class="child">
              <label
                class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5"
                :class="round ? 'tw-text-gray-1020' : 'tw-text-white'"
                >Select round</label
              >
              <select
                id="round"
                v-model="round"
                :disabled="scene > 1"
                @change="onChangeRound"
                :class="[
                  scene === 1 && errors.length > 0 && round === undefined
                    ? 'error select_error'
                    : 'tw-text-black',
                  round !== undefined ? 'tw-font-medium' : 'tw-font-normal',
                ]"
              >
                <option value="undefined" :disabled="true">Select round</option>
                <option v-for="item in rounds" :key="item.displayName" :value="item">
                  {{ item.displayName }}
                </option>
              </select>
            </div>
          </div>

          <div class="parent">
            <div class="child">
              <label
                class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5"
                :class="matchId ? 'tw-text-gray-1020' : 'tw-text-white'"
                >Select match</label
              >
              <select
                id="matchId"
                v-model="matchId"
                :disabled="scene > 1"
                @change="onChangeMatch()"
                :class="[
                  scene === 1 && errors.length > 0 && matchId === undefined
                    ? 'error select_error'
                    : 'tw-text-black',
                  matchId !== undefined ? 'tw-font-medium' : 'tw-font-normal',
                ]"
              >
                <option value="undefined" :disabled="true">Select match</option>
                <option v-for="item in filteredMatches" :key="item._id" :value="item._id">
                  {{
                    `${
                      (item.homeTeam && item.homeTeam.name) || (item.meta.isBye ? "BYE" : "NA")
                    } vs ${
                      (item.awayTeam && item.awayTeam.name) || (item.meta.isBye ? "BYE" : "NA")
                    }`
                  }}
                </option>
              </select>
            </div>
          </div>

          <div class="parent">
            <div class="child">
              <label
                class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5"
                :class="teamId ? 'tw-text-gray-1020' : 'tw-text-white'"
                >Select team</label
              >
              <select
                id="teamId"
                v-model="teamId"
                :disabled="scene > 1"
                :class="[
                  scene === 1 && errors.length > 0 && teamId === undefined
                    ? 'error select_error'
                    : 'tw-text-black',
                  teamId !== undefined ? 'tw-font-medium' : 'tw-font-normal',
                ]"
              >
                <option value="undefined" :disabled="true">Select team</option>
                <option v-for="item in teams" :key="item._id + 'team'" :value="item._id">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="tw-h-12 parent">
          <div class="child">
            <label
              class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5"
              :class="venueName ? 'tw-text-gray-1020' : 'tw-text-white'"
              >Enter venue name</label
            >
            <input
              id="venueName"
              class="search"
              v-model="venueName"
              placeholder="Enter venue name"
              @keyup="suggest"
              autocomplete="on"
              :class="[
                errors.length > 0 && venueName === '' && (scene === 1 || scene === 3)
                  ? 'error venue_error'
                  : 'tw-text-black',
                venueName ? 'tw-font-medium' : 'tw-font-normal',
              ]"
            />
          </div>
        </div>
        <div v-if="venueName" id="suggestions" class="tw-pt-2.5">
          <div
            class="tw-p-2 tw-text-xs tw-bg-gray-200"
            v-for="venueSuggestion of allVenues"
            :key="venueSuggestion._id"
            @click="selectedVenue(venueSuggestion)"
          >
            {{ venueSuggestion.name }}
          </div>
        </div>

        <div class="tw-h-12 tw-mb-4 parent">
          <div class="child">
            <label
              class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5"
              :class="venueFormatted ? 'tw-text-gray-1020' : 'tw-text-white'"
              >Venue address</label
            >
            <input
              id="venueFormatted"
              class="tw-w-full tw-px-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-shadow-none focus:tw-outline-none tw-h-9"
              autocomplete="off"
              placeholder="Venue address"
              v-model="venueFormatted"
              :class="[
                errors.length > 0 && venueFormatted === '' && (scene === 1 || scene === 3)
                  ? 'error'
                  : 'tw-text-black',
                venueFormatted ? 'tw-font-medium' : 'tw-font-normal',
              ]"
              readonly
            />
          </div>
        </div>
      </div>

      <div class="sm:tw-flex sm:tw-justify-center">
        <button
          type="submit"
          class="tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-text-sm tw-capitalize tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-72"
        >
          Continue
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import _ from "lodash";
import { errormsg, roles } from "../../utils/constants";

export default {
  props: ["injury"],
  data() {
    return {
      roles,
      submitted: false,
      sceneType: [],
      competitions: [],
      competition: undefined,
      round: undefined,
      rules: {
        scene: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
        },
        "meta.competition._id": {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (this.injury.scene === 1 && !value)
              return callback(new Error(errormsg.select_option));
            return callback();
          },
        },
        round: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (this.injury.scene === 1 && !value)
              return callback(new Error(errormsg.select_option));
            return callback();
          },
        },
        "meta.matchId": {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (this.injury.scene === 1 && !value)
              return callback(new Error(errormsg.select_option));
            return callback();
          },
        },
        "meta.teamId": {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (this.injury.scene === 1 && !value)
              return callback(new Error(errormsg.select_option));
            return callback();
          },
        },
        "venue.name": {
          required: false,
          message: errormsg.select_option,
          trigger: "blur",
        },
        "venue.formatted": {
          required: false,
          message: errormsg.input_option,
          trigger: "blur",
        },
      },
      allVenues: [],
      moveToNextStep: false,
      errors: [],
      scene: undefined,
      sceneOther: undefined,
      competitionId: undefined,
      round: undefined,
      matchId: undefined,
      teamId: undefined,
      programId: undefined,
      venueName: "",
      venueFormatted: "",
      debounce: false,
      programs: [],
      programMembers: [],
      venueErrorInstance: null,
    };
  },
  computed: {
    rounds() {
      if (this.injury.matches && this.injury.matches.length) {
        return _.chain(this.injury.matches)
          .map((x) => {
            return _.assign(
              {},
              {
                type: x.round.type,
                displayName: x.round.displayName,
                value: x.round.number,
              }
            );
          })
          .orderBy(["type", "value"], ["desc", "asc"])
          .sortedUniqBy("displayName")
          .value();
      }
      return [];
    },
    filteredMatches() {
      if (this.injury.matches && this.injury.matches.length && this.round) {
        return this.injury.matches.filter(
          (x) => x.round.type === this.round.type && x.round.number === this.round.value
        );
      }
      return this.injury.matches;
    },
    teams() {
      let rs = [];
      if (this.scene === 1 && this.matchId) {
        const match = this.injury.matches.find((x) => x._id === this.matchId);
        if (match && match.homeTeam) rs.push(match.homeTeam);
        if (match && match.awayTeam) rs.push(match.awayTeam);
      }
      return rs;
    },
    activeRoleType() {
      return this.$store.getters["user/activeRole"].type;
    },
  },
  async mounted() {
    const type = this.$store.getters["user/activeRole"].type;

    if (type === roles.programAdmin || type === roles.clubProgramAdmin) {
      if (this.injury && this.injury.meta && this.injury.meta.programId)
        this.programId = this.injury.meta.programId;
      this.sceneType = [
        { id: 3, name: "Training" },
        { id: 2, name: "Other" },
      ];
      this.$http
        .get("/nrl/api/v1/admin/programs")
        .then((response) => {
          const allPrograms = response.data.data;
          this.programs = allPrograms.filter((p) => p.isActive !== false);
          // this.programs = response.data.data;
        })
        .catch(() => {
          this.$customError();
        });
    } else if (type === roles.gamedayAdmin) {
      this.sceneType = [{ id: 1, name: "Match" }];
    } else {
      this.sceneType = [
        { id: 1, name: "Match" },
        { id: 3, name: "Training" },
        { id: 2, name: "Other" },
      ];
    }
    try {
      const res = await this.$http.get("/nrl/api/v1/admin/competition-cases/competitions");
      if (res.data.data) {
        this.competitions = res.data.data;
      }

      if (this.injury?.scene) this.scene = this.injury.scene;
      if (this.injury?.sceneOther) this.sceneOther = this.injury.sceneOther;
      if (this.injury?.meta?.competition?._id)
        this.competitionId = this.injury.meta.competition._id;
      if (this.injury?.round) this.round = this.injury.round;
      if (this.injury?.meta?.matchId) this.matchId = this.injury.meta.matchId;
      if (this.injury?.meta?.teamId) this.teamId = this.injury.meta.teamId;
      if (this.injury && this.injury.venue && this.injury.venue.name)
        this.venueName = this.injury.venue.name;
      if (this.injury?.venue?.formatted) this.venueFormatted = this.injury.venue.formatted;
      this.$forceUpdate();
    } catch (e) {
      this.$store.commit("root/loading", false);
      this.$customError(e);
    }
  },
  methods: {
    scrollToElement(refName) {
      var element = document.getElementById(refName);
      element.scrollIntoView({ block: "center" });
    },
    next() {
      this.errors = [];
      // Injury Scene is Match(1), Training(2) , Other(3)
      if (!this.scene) {
        this.scrollToElement("scene");
        this.errors.push("Injury Scene is required");
        return;
      }
      if (this.scene === 2 && !this.sceneOther) {
        this.scrollToElement("sceneOther");
        this.errors.push("Injury Scene location is required");
        return;
      }
      //Injury Scene is Match(1) : mandatory fields
      // if (
      //   this.scene === 1 &&
      //   !(
      //     this.competitionId &&
      //     this.round &&
      //     this.matchId &&
      //     this.teamId &&
      //     this.venueName &&
      //     this.venueFormatted
      //   )
      // )
      //   this.errors.push("Injury details are required");

      if (this.scene === 1) {
        if (!this.competitionId) {
          this.scrollToElement("competitionId");
          this.errors.push("Injury details are required");
          return;
        }
        if (!this.round) {
          this.scrollToElement("round");
          this.errors.push("Injury details are required");
          return;
        }
        if (!this.matchId) {
          this.scrollToElement("matchId");
          this.errors.push("Injury details are required");
          return;
        }
        if (!this.teamId) {
          this.scrollToElement("teamId");
          this.errors.push("Injury details are required");
          return;
        }
      }

      // Venue is mandatory for all injury Scenes
      if (this.scene === 1 || this.scene === 3) {
        if (!this.venueName || !this.venueFormatted) {
          this.scrollToElement("venueName");
          this.errors.push("Injury Venue is required");
        }
      }

      //Success
      if (this.errors.length === 0) {
        this.injury.scene = this.scene;
        if (this.injury.scene === 2) this.injury.sceneOther = this.sceneOther;
        if (this.competitionId) {
          if (this.injury.meta.competition === undefined) this.injury.meta.competition = {};
          this.injury.meta.competition._id = this.competitionId;
          this.injury.meta.competition.name = this.competitions.find(
            (x) => x._id === this.injury.meta.competition._id
          ).name;
        }
        this.injury.round = this.round;
        this.injury.meta.matchId = this.matchId;
        this.injury.meta.teamId = this.teamId;
        if (this.venueName) this.injury.venue.name = this.venueName;
        if (this.venueFormatted) this.injury.venue.formatted = this.venueFormatted;
        this.moveToNextStep = true;
        this.$emit("next", this.injury, this.moveToNextStep);
      }
    },

    resetFields() {
      this.round = undefined;
      this.matchId = undefined;
      this.teamId = undefined;
    },
    async suggest() {
      try {
        const query = this.venueName;

        // Logic for the tooltip/notification popup
        if (query.length > 0 && query.length < 3) {
          if (!this.venueErrorInstance) {
            this.venueErrorInstance = this.$notify.error({
              title: "Input Error",
              message: "Please enter at least 3 characters",
              duration: 0,
            });
          }
          this.allVenues = [];
          this.venueFormatted = "";
          return;
        } else {
          if (this.venueErrorInstance) {
            this.venueErrorInstance.close();
            this.venueErrorInstance = null;
          }
        }

        if (query === "") {
          this.allVenues = [];
          this.venueFormatted = "";
          return;
        }

        if (this.debounce) return;

        this.debounce = true;

        const response = await this.$http.post("/nrl/api/v1/admin/venues/search", {
          criteria: query,
        });

        const allVenues = response.data.data;

        this.allVenues = allVenues.map((x) => ({ ...x, value: x.name }));

        this.debounce = false;
      } catch (e) {
        this.debounce = false;
      }
    },
    selectedVenue(venueSuggestion) {
      if (!venueSuggestion) return;
      this.venueName = venueSuggestion.name;
      this.venueFormatted = venueSuggestion.address.formatted;
      this.injury.venue._id = venueSuggestion._id;
      this.allVenues = [];
    },
    onChangeCompetition(e) {
      this.resetFields();
      this.injury.matches = [];
    },
    onChangeScene(e) {
      this.injury.meta = {
        competition: {
          _id: undefined,
          name: undefined,
        },
        matchId: undefined,
        teamId: undefined,
      };
      this.competitionId = undefined;
      this.matchId = undefined;
      this.teamId = undefined;
      this.round = undefined;
    },
    onChangeMatch() {
      let { meta } = this.injury;
      meta["teamId"] = undefined;
      this.teamId = undefined;
    },
    onChangeRound() {
      let { meta } = this.injury;
      meta["matchId"] = undefined;
      meta["teamId"] = undefined;
      this.matchId = undefined;
      this.teamId = undefined;
    },
    async getProgramMembers() {
      this.injury.meta.programId = this.programId;
      this.program = this.programs.find((p) => p._id === this.programId);
      if (this.program && this.program.venue && this.program.venue.name) {
        this.venueName = this.program.venue.name;

        const response = await this.$http.post("/nrl/api/v1/admin/venues/search", {
          criteria: this.venueName,
        });

        const allVenues = response.data.data;

        const venueAddress = allVenues.find((v) => v.name === this.venueName);

        this.injury.venue._id = venueAddress._id;
        this.venueFormatted = venueAddress.address.formatted;
      }
    },
  },
  watch: {
    competitionId: async function () {
      try {
        if (!this.competitionId) return;
        this.$store.commit("root/loading", true);

        const res = await this.$http.get(
          `/nrl/api/v1/admin/competition-cases/competitions/${this.competitionId}/matches`
        );

        if (!res.data) throw new Error("No Matches available");
        this.injury.matches = res.data.data;
        if (this.clearance === roles.teamAdmin) {
          this.teamId = this.$store.getters["user/activeRole"].entity._id;
        }
        this.$store.commit("root/loading", false);
      } catch (e) {
        this.$store.commit("root/loading", false);
      }
    },
  },
  beforeDestroy() {
    if (this.venueErrorInstance) {
      this.venueErrorInstance.close();
    }
  },
};
</script>
<style lang="scss" scoped>
.btn-control {
  text-align: right;
}
.el-autocomplete,
.el-input,
.el-select {
  width: 100%;
}
::v-deep .el-input {
  .el-input__inner {
    font-size: 16px;
  }
}

select {
  appearance: none; /* Remove default arrow */
  background-image: url("../../assets/chevron_down.svg"); /* Add custom arrow */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: 0px;
  line-height: 0px;
  // height: 0px;
  padding-top: 0px;
  // padding-bottom: 0px;
  padding: 1px 8px 8px 8px;
  @apply tw-w-full focus:tw-outline-none tw-text-sm tw-text-black tw-bg-transparent  tw-border-b-2 tw-border-gray-200 tw-appearance-none;
}

select:disabled {
  background-image: url("../../assets/chevron_down_disabled.svg"); /* Add custom arrow */
  @apply tw-text-gray-300;
}

.search {
  background-image: url("../../assets/searchInBlack.svg"); /* Add custom search */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: 8px;
  @apply tw-w-full tw-col-start-1 tw-col-end-12 tw-px-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-shadow-none focus:tw-outline-none tw-h-9;
}

.error {
  @apply tw-placeholder-red-600 tw-text-red-600;
}

.select_error {
  background-image: url("../../assets/chevron_down_red.svg");
}

.venue_error {
  background-image: url("../../assets/searchInRed.svg");
}

.parent {
  @apply tw-h-70px tw-relative;
}

.child {
  @apply tw-w-full tw-absolute tw-bottom-0;
}
</style>
